import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { damageMissing } from "../../instantAnswers/orders-damagedMissing";
import { failedDeliveryAttempt } from "../../instantAnswers/orders-failedDeliveryAttempt";
import { invoiceDetails } from "../../instantAnswers/orders-invoiceDetails";
import { payoutCalculation } from "../../instantAnswers/orders-payoutCalculation";
import { RequestCommissionChanges } from "../../instantAnswers/orders-requestCommissionChanges";
import { returnedToSender } from "../../instantAnswers/orders-returnedToSender";
import { orderDeliveredStateVisibilityFn, orderShippedOrDeliveredAndSOYOVisibilityFn } from "../../visibilityFunctions/orderStateVisibilityFn";
export var useOrderDeliveredBrandNodes = function useOrderDeliveredBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    DamageMissingItemReportDeliveredState: {
      id: "DamageMissingItemReportDeliveredState",
      label: strictLocalize({
        id: "YJBiao",
        defaultMessage: [{
          "type": 0,
          "value": "Rapport sur un article endommagé ou manquant"
        }]
      }),
      level: 2,
      isNodeVisible: orderDeliveredStateVisibilityFn,
      instantAnswer: damageMissing(strictLocalize)
    },
    PayoutCalculationDeliveredState: {
      id: "PayoutCalculationDeliveredState",
      label: strictLocalize({
        id: "/lzS+4",
        defaultMessage: [{
          "type": 0,
          "value": "Calcul du paiement"
        }]
      }),
      level: 2,
      instantAnswer: payoutCalculation(strictLocalize),
      isNodeVisible: orderDeliveredStateVisibilityFn
    },
    InvoiceDetailsDeliveredState: {
      id: "InvoiceDetailsDeliveredState",
      label: strictLocalize({
        id: "OnTwIg",
        defaultMessage: [{
          "type": 0,
          "value": "Détails de la facture"
        }]
      }),
      level: 2,
      instantAnswer: invoiceDetails(strictLocalize),
      articles: [articles.InvoicesAndBilling.RECEIVE_ORDER_INVOICE],
      isNodeVisible: orderDeliveredStateVisibilityFn
    },
    ProblemWithDeliveryDeliveredState: {
      id: "ProblemWithDeliveryDeliveredState",
      label: strictLocalize({
        id: "+ES+we",
        defaultMessage: [{
          "type": 0,
          "value": "Problème avec la livraison"
        }]
      }),
      children: ["FailedDeliveryAttemptDeliveredState", "ReturnToSenderDeliveredState"],
      level: 2,
      isNodeVisible: orderDeliveredStateVisibilityFn
    },
    FailedDeliveryAttemptDeliveredState: {
      id: "FailedDeliveryAttemptDeliveredState",
      label: strictLocalize({
        id: "sm+jd/",
        defaultMessage: [{
          "type": 0,
          "value": "Échec de la tentative de livraison"
        }]
      }),
      level: 2,
      instantAnswer: failedDeliveryAttempt(strictLocalize),
      isNodeVisible: orderShippedOrDeliveredAndSOYOVisibilityFn
    },
    ReturnToSenderDeliveredState: {
      id: "ReturnToSenderDeliveredState",
      label: strictLocalize({
        id: "l/7+5Z",
        defaultMessage: [{
          "type": 0,
          "value": "Retour à l'expéditeur"
        }]
      }),
      level: 2,
      instantAnswer: returnedToSender(strictLocalize),
      articles: [articles.MyOrders.ORDER_RETURNED_TO_SENDER],
      isNodeVisible: orderDeliveredStateVisibilityFn
    },
    RequestCommissionChangesDeliveredState: {
      id: "RequestCommissionChangesDeliveredState",
      label: strictLocalize({
        id: "/jYVoe",
        defaultMessage: [{
          "type": 0,
          "value": "Demander un ajustement de la commission"
        }]
      }),
      level: 2,
      isNodeVisible: orderDeliveredStateVisibilityFn,
      instantAnswer: RequestCommissionChanges(strictLocalize),
      articles: [articles.FaireDirect.ZERO_COMMISSION]
    }
  };
};